import { TypingContainer, TypingDot } from "./styles"

const TypingIndicator = () => {
   return (
      <TypingContainer>
         <TypingDot $delay="0s" />
         <TypingDot $delay="0.15s" />
         <TypingDot $delay="0.3s" />
      </TypingContainer>
   )
}

export default TypingIndicator
